export const BaseAcademicDegrees = [
  { value: '', label: 'academicDegrees.noDegree' },
  { value: 'Dr.', label: 'academicDegrees.dr' },
  { value: 'Prof.', label: 'academicDegrees.prof' },
];
